import { Toast } from "primereact/toast";
import React from "react";
import { ProgramChartData } from "../../../../../Controllers/Types/Project/DefaultService/ProgramInterface";
import { Dialog } from "primereact/dialog";
import { Ripple } from "primereact/ripple";

interface ProgramChartModalProps {
    isOpen: boolean;
    view: 'floor' | 'task';
    onClose: () => void;
    toast: React.RefObject<Toast>;
    programmeChartData?: ProgramChartData | null;
}

const ProgramChartModal: React.FC<ProgramChartModalProps> = ({ isOpen, view, onClose, toast, programmeChartData }) => {

    const modalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Program data by {view}
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={onClose}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    return (
        <Dialog
            visible={isOpen}
            header={modalHeader}
            headerClassName="custom_modal_header full_view_modal_header with_bg"
            className="custom_modal_dialog modal_dialog_full"
            onHide={onClose}
            contentClassName="full_view_modal_content"
            dismissableMask
        >
            <div className="full_view_modal_body">
                <div className="gantt_chart_container">

                </div>
            </div>
        </Dialog>
    )
}

export default ProgramChartModal